import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './components/Header';
import AnnouncementMock from './pages/AnnouncementMock';
import Announcement from './pages/Announcement';
import System from './pages/System';
import Information from './pages/Information';
import './App.css';

function App() {
  return (
    <Router>
      <Box className="App">
        <Header />
        <Box className="main-content">
          <Routes>
            <Route path="/" element={<Navigate to="/announcement" replace />} />
            <Route path="/announcement" element={<Announcement />} />
            <Route path="/system" element={<System />} />
            <Route path="/information" element={<Information />} />
          </Routes>
        </Box>
      </Box>
    </Router>
  );
}

export default App;
